(() => {
  if (window.__happyneonCartWishlistLoaded) return;
  window.__happyneonCartWishlistLoaded = true;

  const storageKey = "happyneon_wishlist_v1";
  const maximumProducts = 4;
  const productCache = new Map();
  let renderVersion = 0;

  const wishlistConfig = () => {
    const header = document.querySelector("#SiteHeader");
    return {
      url: header?.dataset.wishlistUrl || "",
      title: header?.dataset.wishlistCartTitle || "",
      linkLabel: header?.dataset.wishlistCartLinkLabel || ""
    };
  };

  const applyWishlistConfig = (container) => {
    const config = wishlistConfig();
    const title = container.querySelector(".cart-saved-for-later__title");
    const link = container.querySelector(".cart-saved-for-later__link");

    if (title && config.title) title.textContent = config.title;
    if (link && config.linkLabel) link.textContent = config.linkLabel;
    if (link && config.url) link.href = config.url;
    if (config.url) container.dataset.wishlistUrl = config.url;
  };

  const escapeHtml = (value) => String(value ?? "").replace(/[&<>"']/g, (character) => ({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#039;"
  })[character]);

  const readWishlist = () => {
    try {
      const value = JSON.parse(window.localStorage.getItem(storageKey) || "[]");
      return Array.isArray(value) ? [...new Set(value.filter(Boolean))] : [];
    } catch {
      return [];
    }
  };

  const rootUrl = () => {
    const root = window.Shopify?.routes?.root || "/";
    return root.endsWith("/") ? root : `${root}/`;
  };

  const getCart = async () => {
    try {
      const response = await fetch(`${rootUrl()}cart.js`, { credentials: "same-origin" });
      return response.ok ? await response.json() : { items: [] };
    } catch {
      return { items: [] };
    }
  };

  const getCartHandles = (cart) => new Set((cart?.items || []).map((item) => {
    if (item.handle) return item.handle;
    if (item.product_handle) return item.product_handle;
    return String(item.url || "").match(/\/products\/([^/?#]+)/)?.[1] || "";
  }).filter(Boolean));

  const getProduct = async (handle) => {
    if (!productCache.has(handle)) {
      productCache.set(handle, fetch(`${rootUrl()}products/${encodeURIComponent(handle)}.js`, {
        credentials: "same-origin"
      }).then((response) => response.ok ? response.json() : null).catch(() => null));
    }
    return productCache.get(handle);
  };

  const formatMoney = (cents, format) => {
    const amount = (Number(cents || 0) / 100).toFixed(2);
    return String(format || "${{amount}}")
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(Number(amount))))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace(".", ","))
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/<[^>]*>/g, "");
  };

  const productCard = (product, moneyFormat) => {
    const image = product.featured_image || product.images?.[0] || "";
    const sizedImage = image ? `${image}${image.includes("?") ? "&" : "?"}width=360` : "";
    const url = `${rootUrl()}products/${product.handle}`;
    return `
      <article class="cart-saved-for-later__card">
        <a class="cart-saved-for-later__image" href="${escapeHtml(url)}">
          ${sizedImage ? `<img src="${escapeHtml(sizedImage)}" alt="${escapeHtml(product.title)}" loading="lazy" width="360" height="360">` : ""}
        </a>
        <h3><a href="${escapeHtml(url)}">${escapeHtml(product.title)}</a></h3>
        <p class="cart-saved-for-later__price">${escapeHtml(formatMoney(product.price, moneyFormat))}</p>
      </article>`;
  };

  const render = async (providedCart) => {
    const containers = [...document.querySelectorAll("[data-hn-cart-wishlist]")];
    if (!containers.length) return;

    const version = ++renderVersion;
    const wishlist = readWishlist();
    if (!wishlist.length) {
      containers.forEach((container) => {
        container.hidden = true;
        const grid = container.querySelector("[data-hn-cart-wishlist-grid]");
        if (grid) grid.innerHTML = "";
      });
      return;
    }

    const cart = providedCart?.items ? providedCart : await getCart();
    const cartHandles = getCartHandles(cart);
    const eligibleHandles = [...wishlist].reverse().filter((handle) => !cartHandles.has(handle)).slice(0, 10);

    const products = (await Promise.all(eligibleHandles.map(getProduct)))
      .filter((product) => product && product.available !== false)
      .slice(0, maximumProducts);

    if (version !== renderVersion) return;

    containers.forEach((container) => {
      applyWishlistConfig(container);
      const grid = container.querySelector("[data-hn-cart-wishlist-grid]");
      if (!grid) return;
      grid.innerHTML = products.map((product) => productCard(product, container.dataset.moneyFormat)).join("");
      container.hidden = products.length === 0;
    });
  };

  document.addEventListener("happyneon:wishlist-change", () => render());
  document.addEventListener("cart:updated", (event) => render(event.detail?.cart));
  document.addEventListener("cart:open", () => render());
  window.addEventListener("storage", (event) => {
    if (event.key === storageKey) render();
  });

  render();
})();
